/* Global imports */
import React from 'react'
import styled from 'styled-components'
import { Grid,Progress, Segment } from 'semantic-ui-react'

/* Local imports */
import Text from 'Components/Text'
import { getCompletedStepCount, getStepCount } from 'Utils'
import useResults from 'Hooks/useResults'
import useSession from 'Hooks/useSession'
import { isExerciseCompleted } from 'Utils'

/* Component definition */
const ProgressBar = ({ exercise }) => {
  const { isPlus } = useSession()
  const { results, temporaryResults } = useResults()

  const activeResults = isExerciseCompleted(exercise, results) ? temporaryResults : results

  return (
    <SSegment disabled={false}>
    <Grid>
      <Grid.Column style={{paddingTop: '8px'}} width={16}>
        <Text as="h6" style={{ color: '#02339c', textAlign: 'center' }} className={isPlus ? 'plusText' : ''}>trainingOverview.progress</Text>
      </Grid.Column>
      <Grid.Column width={16}>
        <div style={{ textAlign: 'center' }}>
          <Progress
            autoSuccess
            percent={getExerciseProgress(exercise, activeResults)}
            size="tiny"
            indicating
          />
          <Text className="caption" as="p" notr>{`${getExerciseProgress(exercise, activeResults)} %`}</Text>
        </div>
      </Grid.Column>
    </Grid>
  </SSegment>

  )
}
/* PropTypes */
ProgressBar.propTypes = {}
ProgressBar.defaultProps = {}

/* Local utility functions */
const getExerciseProgress = (exercise, results) => {
  return (getCompletedStepCount(exercise, results) / getStepCount(exercise) * 100).toFixed(0)
}

/* Styles */
const SSegment = styled(Segment)`
  height: 85px !important;
  margin-bottom: 16px !important;
`
export default ProgressBar